<template>
  <Modal v-model="priceSyncRulesModal" :title="priceSyncRulesTitle" width="500" :transfer="false"
    :mask-closable="false" @on-visible-change="priceSyncRulesChange">
    <Form ref="priceSyncRulesForm" :model="priceSyncRulesForm" :rules="ruleValidate" :label-width="90" @submit.native.prevent>
      <Row style="width: 90%;">
        <h2 class="mb12 font-size-14 flex flex-wrap pl29">
          <span>{{ $t('key1005636') }}</span>
          <span class="distributorThemeColor cursor ml3 mr3" @click="goToListingPage('/yms/listing/template/index.htm')">{{ $t('key1005622') }}</span>
          <span>{{ $t('key1005637') }}</span>
        </h2>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1005351')" prop="platformId">
            <Select v-model="priceSyncRulesForm.platformId" filterable transfer :placeholder="$t('key1005631')" @on-change="changePlatform">
              <Option v-for="item in platformList" :value="item.platformId">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1000666')" prop="shopId">
            <Select v-model="priceSyncRulesForm.shopId" :disabled="!priceSyncRulesForm.platformId"
              filterable transfer @on-change="changeStore">
              <Option v-for="(item, index) in publishStoreList" :value="item.saleAccountId" :key="index">{{ item.account }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1000667')" prop="templateId">
            <Select v-model="priceSyncRulesForm.templateId" filterable transfer :disabled="!priceSyncRulesForm.shopId">
              <Option v-for="(item, index) in listingsTemplateList" :value="item.templateId" :key="index">{{ item.templateName }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001522')" :label-width="68" prop="status" class="radio_styles_distributor">
            <RadioGroup v-model="priceSyncRulesForm.status">
              <Radio :label="1">{{ $t('key1000462') }}</Radio>
              <Radio :label="0">{{ $t('key1000463') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="priceSyncRulesModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="priceSyncRulesBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "priceSyncRulesModal",
  mixins: [Mixin],
  props: {
    platformList: { // 适用平台
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      priceSyncRulesModal: false,
      priceSyncRulesTitle: '',
      priceSyncRulesForm: {
        platformId: null,
        shopId: null, // 刊登店铺
        templateId: null, // 刊登模板
        status: 1
      },
      ruleValidate: {
        platformId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005631'), trigger: 'change'},
        ],
        shopId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005632'), trigger: 'change'}
        ],
        templateId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000661'), trigger: 'change'}
        ]
      },
      publishStoreList: [],
      listingsTemplateList: [],
      ruleType: null,
      autoRuleId: null
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  methods: {
    // 初始化数据
    initPriceSyncRulesData(type, autoRuleId) {
      let obj = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005633'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005634')
      };
      this.ruleType = type;
      this.priceSyncRulesTitle = obj[type];
      if (type === 'edit') {
        this.getPriceSyncRulesData(autoRuleId);
      } else {
        this.priceSyncRulesModal = true;
      }
    },
    // 获取规则详情数据
    getPriceSyncRulesData(autoRuleId) {
      let v = this;
      v.axios.get(api.get_ymsProductPriceSynRule + autoRuleId, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.autoRuleId = data.autoRuleId;
            v.priceSyncRulesForm.status = data.status;
            let autoRuleActionResults = data.ruleActions || [];
            if (autoRuleActionResults.length > 0) {
              autoRuleActionResults.map((ele) => {
                if (ele.type === 'PRODUCT_PRICE_SYN_RULE') {
                  let obj = JSON.parse(ele.value);
                  v.priceSyncRulesForm.platformId = obj.platformId;
                  v.changePlatform(obj.platformId, obj, 'update');
                }
              });
            }
            v.priceSyncRulesModal = true;
          }
        }
      });
    },
    // 保存按钮
    priceSyncRulesBtn() {
      let v = this;
      let query = {};
      let url = '';
      let method = '';
      let text = '';
      let values = {
        platformId: v.priceSyncRulesForm.platformId,
        shopId: v.priceSyncRulesForm.shopId,
        templateId: v.priceSyncRulesForm.templateId,
      };
      query = {
        autoRuleActions: [
          {
            type: 'PRODUCT_PRICE_SYN_RULE',
            value: JSON.stringify(values)
          }
        ],
        businessId: v.userInfo.merchantId, // 落到商户级别
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005635'),
        status: v.priceSyncRulesForm.status
      };
      if (v.ruleType === 'add') {
        url = api.post_ymsProductPriceSynRule_insert;
        method = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000113');
      } else {
        url = api.put_ymsProductPriceSynRule_update;
        method = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161');
        query.autoRuleId = v.autoRuleId;
      }
      v.$refs['priceSyncRulesForm'].validate((valid) => {
        if (valid) {
          v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.priceSyncRulesModal = false;
              v.$Message.success(text);
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 获取对应平台的店铺数据
    getPublishStoreData(obj, type) {
      let v = this;
      let query = {
        platformId: v.priceSyncRulesForm.platformId,
        status: 1 // 1'‑启用 '0'‑停用
      };
      v.publishStoreList = [];
      v.axios.post(api.post_ymsDistributorProductInfo_querySaleAccountInfoListByPlatform, query).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            data.map((item) => {
              let accountInfoList = item.accountInfoList || [];
              if (accountInfoList.length > 0) {
                v.publishStoreList.push(...accountInfoList);
              }
            });
            if (type === 'update') {
              v.priceSyncRulesForm.shopId = obj.shopId;
              v.changeStore(obj.shopId, obj, type);
            }
          }
        }
      });
    },
    // 选择适用平台
    changePlatform(val, obj, type) {
      this.priceSyncRulesForm.shopId = null;
      this.publishStoreList = [];
      if (val) {
        this.getPublishStoreData(obj, type);
      }
    },
    // 选择刊登店铺
    changeStore(val, obj, type) {
      this.priceSyncRulesForm.templateId = null;
      this.listingsTemplateList = [];
      if (val) {
        this.getListingsTemplateData(obj, type);
      }
    },
    // 获取对应平台刊登的模版数据
    getListingsTemplateData(obj, type) {
      let v = this;
      let query = {
        platformId: v.priceSyncRulesForm.platformId,
        saleAccountId: v.priceSyncRulesForm.shopId,
        siteIds: []
      };
      v.listingsTemplateList = [];
      v.axios.post(api.post_ymsDistributorProductInfo_queryTemplateByPlatform, query).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            data.map((item) => {
              let templateInfoList = item.templateInfoList || [];
              if (templateInfoList.length > 0) {
                v.listingsTemplateList.push(...templateInfoList);
              }
            });
            if (type === 'update') {
              v.priceSyncRulesForm.templateId = obj.templateId;
            }
          }
        }
      });
    },
    // 监听弹窗
    priceSyncRulesChange(value) {
      if (!value) {
        let v = this;
        v.$nextTick(() => {
          v.$refs['priceSyncRulesForm'].resetFields();
        });
        this.autoRuleId = null;
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ivu-form-item-label, label {
  font-size: 13px !important;
}
</style>